/**
 * utils/paramDisplay.ts
 *
 * Affichage lisible des valeurs de la table `parameters`.
 * Ex. `default_country` = 'MA' → '🇲🇦 Maroc (+212)' au lieu du code ISO brut.
 */
import { COUNTRIES } from '../constants/countries';

/** Libellé complet d'un pays depuis son code ISO (le code seul si inconnu). */
export function countryLabel(code: string, lang: string): string {
  const c = COUNTRIES.find(x => x.code === code);
  if (!c) return code;
  return `${c.flag} ${c.name[lang as 'ar' | 'fr' | 'en'] || c.name.ar} (+${c.dialCode})`;
}

/**
 * Valeur d'un paramètre telle qu'affichée dans les tableaux.
 * Les paramètres dont la valeur est un code technique (pays) sont rendus en clair ;
 * la valeur brute reste celle envoyée à l'API lors de l'enregistrement.
 */
export function formatParamValue(name: string, value: string, lang: string): string {
  if (!value) return value ?? '';
  if (name === 'default_country') return countryLabel(value, lang);
  return value;
}
